/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import PersonMatches from 'DesignSystem/PersonMatches/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content/Matches/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newPatientPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'person.first_name',
})
let newPatientPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'person.last_name',
})
let newPatientPersonBirthDateValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'person.birth_date',
})
let onIgnoreMatches = fromHelpers.useOnIgnoreMatches({
  children,
  viewPath
  
})
let onUseSelectedLead = fromHelpers.useOnUseSelectedLead({
  children,
  viewPath
  
})
let onUseSelectedPatient = fromHelpers.useOnUseSelectedPatient({
  children,
  viewPath
  
})
let onUseSelectedPerson = fromHelpers.useOnUseSelectedPerson({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PersonMatches
  viewPath={`${viewPath}/PersonMatches`}
 data="new_patient.person.first_name"
 firstName={newPatientPersonFirstNameValueData}
 data="new_patient.person.last_name"
 lastName={newPatientPersonLastNameValueData}
 data="new_patient.person.birth_date"
 birthDate={newPatientPersonBirthDateValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onCancel={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onIgnoreMatches={onIgnoreMatches}
 onUseSelectedLead={onUseSelectedLead}
 onUseSelectedPatient={onUseSelectedPatient}
 onUseSelectedPerson={onUseSelectedPerson}
/>
{children}
</React.Fragment>)
}